import "./service.css";
import { useTranslation } from "../../shared/LanguageContext";

const Service = () => {
  const { t } = useTranslation();
  return (
  <div className="services-parent" id="service">
    <div className="div1 service-card">
      <div className="service-icon"><i className="bi bi-heart-pulse"></i></div>
      <div className="service-head"><h5>{t("srv_1_head")}</h5></div>
      <div className="service-body">{t("srv_1_body")}</div>
    </div>
    <div className="div2 service-card">
      <div className="service-icon"><i className="bi bi-person-vcard"></i></div>
      <div className="service-head"><h5>{t("srv_2_head")}</h5></div>
      <div className="service-body">{t("srv_2_body")}</div>
    </div>
    <div className="div3 service-card">
      <div className="service-icon"><i className="bi bi-capsule"></i></div>
      <div className="service-head"><h5>{t("srv_3_head")}</h5></div>
      <div className="service-body">{t("srv_3_body")}</div>
    </div>
    <div className="div4 service-card">
      <div className="service-icon"><i className="bi bi-hospital"></i></div>
      <div className="service-head"><h5>{t("srv_5_head")}</h5></div>
      <div className="service-body">{t("srv_5_body")}</div>
    </div>
    <div className="div5 service-card">
      <div className="service-icon"><i className="bi bi-bandaid"></i></div>
      <div className="service-head"><h5>{t("srv_6_head")}</h5></div>
      <div className="service-body">{t("srv_6_body")}</div>
    </div>
    <div className="div6 service-card">
      <div className="service-icon"><i className="bi bi-exclamation-triangle"></i></div>
      <div className="service-head"><h5>{t("srv_7_head")}</h5></div>
      <div className="service-body">{t("srv_7_body")}</div>
    </div>
  </div>
  );
};

export default Service;
